import { useAuth0 } from "@auth0/auth0-react";
import { useCurrentUserQuery } from "./user";

type AuthenticatedUser = {
  user: {
    id: string;
    firstName: string;
    lastName: string;
    isAdmin: boolean;
    isIngkaUser: boolean;
  };
};

export const useAuth = (): AuthenticatedUser => {
  const { user: auth0User } = useAuth0();
  const { data: currentUser } = useCurrentUserQuery();

  return auth0User
    ? {
        user: {
          id:
            auth0User["https://accounts.ikea.com/oid"] ||
            (auth0User.sub as string),
          firstName: auth0User.given_name as string,
          lastName: auth0User.family_name as string,
          isAdmin: currentUser?.isAdmin ?? false,
          isIngkaUser: currentUser?.isIngkaUser ?? false,
        },
      }
    : {
        user: {
          id: "invalid",
          firstName: "",
          lastName: "",
          isAdmin: false,
          isIngkaUser: false,
        },
      };
};
